import script from "./SetStatusPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetStatusPage.vue?vue&type=script&lang=ts&setup=true"

import "./SetStatusPage.vue?vue&type=style&index=0&id=4b459fb0&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b459fb0"]])

export default __exports__